import AppRouter from './AppRouter';
import IframeGuard from "./IframeGuard";
import { BrowserRouter } from 'react-router-dom';
import './App.css';

const App: React.FC<{}> = () => (
    <BrowserRouter>
      <IframeGuard>
        <AppRouter />
      </IframeGuard>
    </BrowserRouter>
);

export default App;